(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['moment', 'torso/modules/NestedModel', 'services/demographicsExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var demographicsExtService = require('./../urls').demographicsExtService;
    module.exports = factory(require('moment'), require('backbone-torso/modules/NestedModel'), demographicsExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(moment, TorsoNestedModel, demographicsExtService) {
  'use strict';

  /**
   * Model for user information. Uses the DemographicsExtService and corresponds to a DemographicsDTO
   *
   * @class DemographicsModel
   * @extends Torso.NestedModel
   * @constructor
   */
  return TorsoNestedModel.extend({
    urlRoot: demographicsExtService,
    idAttribute: 'vecnaId',

    /**
     * @method parse
     * @override
     */
    parse: function(response) {
      response.demographicsWithPendingProperties = response.pendingDemographics || response.acceptedDemographics;
      return response;
    },

    /**
     * Return the age of the patient in years.
     * @return {Number} the age of the patient in years.
     */
    getAge: function() {
      var dobString = this.get('acceptedDemographics.dob');
      var dob = moment(dobString);
      var now = moment();
      var ageFloat = now.diff(dob, 'years', true);
      return Math.floor(ageFloat);
    }
  });
}));
